import { MadSDKAPIError } from "../../../../../errors/base";
export class DealIdOptionsFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, DealIdOptionsFetchFailed);
        }
        this.name = "DealIdOptionsFetchFailed";
        this.message = "Failed to fetch Deal ID options. Please try again at a later time.";
    }
}
//# sourceMappingURL=errors.js.map